interface ProductWithType {
  product_type?: string | null;
  name?: string;
}

export interface SyringeCheckResult {
  needsWarning: boolean;
  injectableMedications: string[];
}

/**
 * Check if any selected products are injectables without a syringe.
 * Returns a warning result if injectables are present but no syringe is included.
 */
export function checkSyringeNeeded(products: ProductWithType[]): SyringeCheckResult {
  const hasInjectable = products.some(p => p.product_type === 'injectable');
  const hasSyringe = products.some(p => p.product_type === 'syringe');

  if (hasInjectable && !hasSyringe) {
    const injectableMedications = products
      .filter(p => p.product_type === 'injectable')
      .map(p => p.name || 'Unknown');
    return { needsWarning: true, injectableMedications };
  }

  return { needsWarning: false, injectableMedications: [] };
}
